import {
  GAME_MOVES_KEY,
  deriveCheckers,
  gameDocName,
  type CheckersMove,
  type CheckersState,
} from '@awwyeah/shared';
import type * as Y from 'yjs';
import { useYArray, useYDoc } from '../../sync';

/**
 * Checkers' own move log + derived board (WS-17d) — the same shape as Connect-4's
 * `useGameMoves.ts`, just typed to `CheckersMove`/`CheckersState`. Kept as its own hook
 * (rather than generalizing `useGameMoves`) so touching Connect-4's file stays unnecessary —
 * see `GameBoardPage.tsx`'s kind-dispatch guard for how the two plug into the same shell.
 */
export function useCheckersMoves(
  gameId: string,
  playerIds: readonly [string, string],
): {
  doc: Y.Doc;
  movesArray: Y.Array<CheckersMove>;
  moves: CheckersMove[];
  state: CheckersState;
} {
  const doc = useYDoc(gameDocName(gameId));
  const { array, items } = useYArray<CheckersMove>(doc, GAME_MOVES_KEY);
  const state = deriveCheckers(items, playerIds);
  return { doc, movesArray: array, moves: items, state };
}
